export enum SystemMessage {
  UNKNOWN_ERROR = "Có lỗi xảy ra",
  DO_NOT_PERMISSION = "Bạn không có quyền truy cập",
  REGISTER_SUCCESS = "Đăng ký thành công",
  CREATE_SUCCESSFULLY = "Tạo thành công",
  DELETE_SUCCESSFULLY = "Xóa thành công",
}
